import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { UpaUserProfileDataModel, Validation } from '../../../Core/models';
import { PrimaryDOBValidationService, SwProcessStateService, CommonService, StartUpConfigUiService } from '../../../Core/Services';
import { take } from 'rxjs/operators';
declare function maskingDob(): any;


@Component({
  selector: '[app-primary-dob]',
  templateUrl: './primary-dob.component.html',
  styleUrls: ['./primary-dob.component.css']
})
export class PrimaryDobComponent implements OnInit {

  constructor(private commonService: CommonService,private primaryDOBValidationService: PrimaryDOBValidationService, private swProcessStateService: SwProcessStateService, private configUiService: StartUpConfigUiService) { }
  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

  public errorClass = '';
  public error: Validation = new Validation();
  public flag: number;
  public DOB: String;
  @Input() isUpaEnable: boolean = false;
  @Input() isUserLoggedIn: boolean = false;
  @Input() upaUserData: UpaUserProfileDataModel;


  ngOnInit() {
    maskingDob();

    this.primaryDOBValidationService.dobValid$.subscribe({
      next: (error) => {
        if (error && error.isInValid) {

          this.error.isInValid = error.isInValid;
          document.getElementById("lblDateInput").classList.add(error.errorCss);
          document.getElementById("txtDateInput").classList.add(error.errorCss);
          document.getElementById("error-date1").classList.remove('hidden');
        }
        else {
          this.error.isInValid = error.isInValid;
          document.getElementById("lblDateInput").classList.remove('error');
          document.getElementById("txtDateInput").classList.remove('error');
          document.getElementById("error-date1").classList.add('hidden');
        }
      }
    })
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.swDOB();
      } 
    })
  }
  swDOB() {
    this.swProcessStateService.swProcessModel$.pipe(take(1)).subscribe(swInput => {
      this.DOB = this.commonService.customDateFormat(swInput?.policyHolder[0]?.birthDate, 'dd/MM/yyyy')
    })
  }

  ngOnChanges() {
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        this.DOB = this.commonService.customDateFormat(this.upaUserData.dateOfBirth, 'dd/MM/yyyy');
        this.submitAnswer(this.DOB);
      }
    })
  }

  submitAnswer(date) {
    
    this.onSubmit.emit(date)
  }

}
